import { useCallback } from 'react';
import { useSocketEvent } from '@connect-x-app/hybrid-data-access';
import { ChatConnectivityUpdated, UserUpdateEvent } from '@connect-x-app/shared-domain-models';

import { useSocketStore, useUsersStore } from '../../stores';

export const useUserSocketEvents = () => {
  const { socket } = useSocketStore();
  const { updateKnownUser, updateUserConnectivityStatus } = useUsersStore();

  const processUserUpdate = useCallback((user: UserUpdateEvent) => updateKnownUser(user), [updateKnownUser]);

  const processUserConnectivityStatusUpdate = useCallback(
    ({ participant }: ChatConnectivityUpdated) =>
      // remove mapping when backend sends out connectivity status uppercase again
      updateUserConnectivityStatus(participant.externalId, participant.connectivity),
    [updateUserConnectivityStatus],
  );

  useSocketEvent(socket, 'user.update', processUserUpdate);
  useSocketEvent(socket, 'chat.connectivity-updated', processUserConnectivityStatusUpdate);
};
